/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ValidateTokenRequest } from '../models/ValidateTokenRequest';
import type { ValidateTokenResponse } from '../models/ValidateTokenResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvitationsService {
    /**
     * Validate a magic link token
     * Validates a magic link token from an invitation email and returns user information if valid.
     * @param requestBody
     * @returns ValidateTokenResponse Successful Response
     * @throws ApiError
     */
    public static validateInvitationToken(
        requestBody: ValidateTokenRequest,
    ): CancelablePromise<ValidateTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invitations/validate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
